// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"867b8843","106":"7232e45f","292":"0e474aab","387":"0a59dad0","453":"79207b79","468":"7934b431"}[chunkId] + ".chunk.js";
};